import { Box, type BoxProps } from '@mui/material';
import { useEffect, useState } from 'react';

import { api } from '../lib/api';

type AuthMediaProps = Omit<BoxProps<'img'>, 'component' | 'src'> & {
  src: string | null | undefined;
  alt: string;
};

export function AuthMedia({ src, alt, sx, ...props }: AuthMediaProps) {
  const isAuthAsset = Boolean(src?.startsWith('/api/v1/'));
  const [resolvedSrc, setResolvedSrc] = useState<string | null>(null);

  useEffect(() => {
    if (!src || !isAuthAsset) {
      setResolvedSrc(null);
      return undefined;
    }

    let objectUrl: string | null = null;
    let cancelled = false;

    void api
      .get(src.replace('/api/v1', ''), { responseType: 'blob' })
      .then((response) => {
        if (cancelled) {
          return;
        }

        objectUrl = URL.createObjectURL(response.data);
        setResolvedSrc(objectUrl);
      })
      .catch(() => {
        if (!cancelled) {
          setResolvedSrc(null);
        }
      });

    return () => {
      cancelled = true;
      if (objectUrl) {
        URL.revokeObjectURL(objectUrl);
      }
    };
  }, [isAuthAsset, src]);

  if (!src) {
    return <Box sx={{ ...sx, bgcolor: 'rgba(255,255,255,0.04)' }} />;
  }

  if (!isAuthAsset) {
    return <Box component="img" src={src} alt={alt} sx={sx} {...props} />;
  }

  if (!resolvedSrc) {
    return <Box sx={{ ...sx, bgcolor: 'rgba(255,255,255,0.04)' }} />;
  }

  return <Box component="img" src={resolvedSrc} alt={alt} sx={sx} {...props} />;
}
